// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Generated from: metadata_0.0.9.json
// Generated at: 2026-03-12T09:23:49.796Z
// Total pieces: 254

/**
 * Static piece metadata for fast frontend rendering without API calls.
 * Contains displayName and logoUrl for all community pieces.
 */
export const PIECE_LOGOS: Record<
  string,
  { displayName: string; logoUrl: string }
> = {
  '@activepieces/piece-activecampaign': {
    displayName: 'ActiveCampaign',
    logoUrl: '/img/piece/community/activecampaign.png',
  },
  '@activepieces/piece-activepieces': {
    displayName: 'Activepieces Platform',
    logoUrl: '/img/piece/community/activepieces.png',
  },
  '@activepieces/piece-actualbudget': {
    displayName: 'Actual Budget',
    logoUrl: '/img/piece/community/actualbudget.png',
  },
  '@activepieces/piece-acumbamail': {
    displayName: 'Acumbamail',
    logoUrl: '/img/piece/community/acumbamail.png',
  },
  '@activepieces/piece-afforai': {
    displayName: 'Afforai',
    logoUrl: '/img/piece/community/afforai.png',
  },
  '@activepieces/piece-aianswer': {
    displayName: 'AI Answer',
    logoUrl: '/img/piece/community/aianswer.png',
  },
  '@activepieces/piece-airtable': {
    displayName: 'Airtable',
    logoUrl: '/img/piece/community/airtable.png',
  },
  '@activepieces/piece-apitable': {
    displayName: 'AITable',
    logoUrl: '/img/piece/community/apitable.png',
  },
  '@activepieces/piece-amazon-s3': {
    displayName: 'Amazon S3',
    logoUrl: '/img/piece/community/amazon-s3.png',
  },
  '@activepieces/piece-amazon-sqs': {
    displayName: 'Amazon SQS',
    logoUrl: '/img/piece/community/amazon-sqs.png',
  },
  '@activepieces/piece-aminos': {
    displayName: 'Aminos',
    logoUrl: '/img/piece/community/aminos.png',
  },
  '@activepieces/piece-claude': {
    displayName: 'Anthropic Claude',
    logoUrl: '/img/piece/community/claude.png',
  },
  '@activepieces/piece-apify': {
    displayName: 'Apify',
    logoUrl: '/img/piece/community/apify.svg',
  },
  '@activepieces/piece-apollo': {
    displayName: 'Apollo',
    logoUrl: '/img/piece/community/apollo.png',
  },
  '@activepieces/piece-approval': {
    displayName: 'Approval',
    logoUrl: '/img/piece/community/approval.svg',
  },
  '@activepieces/piece-asana': {
    displayName: 'Asana',
    logoUrl: '/img/piece/community/asana.png',
  },
  '@activepieces/piece-ashby': {
    displayName: 'Ashby',
    logoUrl: '/img/piece/community/ashby.png',
  },
  '@activepieces/piece-assemblyai': {
    displayName: 'AssemblyAI',
    logoUrl: '/img/piece/community/assemblyai.png',
  },
  '@activepieces/piece-azure-communication-services': {
    displayName: 'Azure Communication Services',
    logoUrl:
      'https://cdn.activepieces.com/pieces/azure-communication-services.png',
  },
  '@activepieces/piece-azure-openai': {
    displayName: 'Azure OpenAI',
    logoUrl: '/img/piece/community/azure-openai.png',
  },
  '@activepieces/piece-bamboohr': {
    displayName: 'BambooHR',
    logoUrl: '/img/piece/community/bamboohr.png',
  },
  '@activepieces/piece-bannerbear': {
    displayName: 'Bannerbear',
    logoUrl: '/img/piece/community/bannerbear.png',
  },
  '@activepieces/piece-baserow': {
    displayName: 'Baserow',
    logoUrl: '/img/piece/community/baserow.png',
  },
  '@activepieces/piece-beamer': {
    displayName: 'Beamer',
    logoUrl: '/img/piece/community/beamer.png',
  },
  '@activepieces/piece-bettermode': {
    displayName: 'Bettermode',
    logoUrl: '/img/piece/community/bettermode.png',
  },
  '@activepieces/piece-binance': {
    displayName: 'Binance',
    logoUrl: '/img/piece/community/binance.png',
  },
  '@activepieces/piece-bonjoro': {
    displayName: 'Bonjoro',
    logoUrl: '/img/piece/community/bonjoro.png',
  },
  '@activepieces/piece-box': {
    displayName: 'Box',
    logoUrl: '/img/piece/community/box.png',
  },
  '@activepieces/piece-sendinblue': {
    displayName: 'Brevo',
    logoUrl: '/img/piece/community/sendinblue.png',
  },
  '@activepieces/piece-brilliant-directories': {
    displayName: 'Brilliant Directories',
    logoUrl: '/img/piece/community/brilliant-directories.png',
  },
  '@activepieces/piece-bubble': {
    displayName: 'Bubble',
    logoUrl: '/img/piece/community/bubble.png',
  },
  '@activepieces/piece-cal-com': {
    displayName: 'Cal.com',
    logoUrl: '/img/piece/community/cal-com.png',
  },
  '@activepieces/piece-calendly': {
    displayName: 'Calendly',
    logoUrl: '/img/piece/community/calendly.png',
  },
  '@activepieces/piece-captain-data': {
    displayName: 'Captain-data',
    logoUrl: '/img/piece/community/captain-data.png',
  },
  '@activepieces/piece-cartloom': {
    displayName: 'Cartloom',
    logoUrl: '/img/piece/community/cartloom.png',
  },
  '@activepieces/piece-certopus': {
    displayName: 'Certopus',
    logoUrl: '/img/piece/community/certopus.png',
  },
  '@activepieces/piece-chargekeep': {
    displayName: 'ChargeKeep',
    logoUrl: '/img/piece/community/chargekeep.png',
  },
  '@activepieces/piece-clarifai': {
    displayName: 'Clarifai',
    logoUrl: '/img/piece/community/clarifai.png',
  },
  '@activepieces/piece-clearout': {
    displayName: 'Clearout',
    logoUrl: '/img/piece/community/clearout.png',
  },
  '@activepieces/piece-clickup': {
    displayName: 'ClickUp',
    logoUrl: '/img/piece/community/clickup.png',
  },
  '@activepieces/piece-clockodo': {
    displayName: 'Clockodo',
    logoUrl: '/img/piece/community/clockodo.png',
  },
  '@activepieces/piece-confluence': {
    displayName: 'Confluence',
    logoUrl: '/img/piece/community/confluence.png',
  },
  '@activepieces/piece-connections': {
    displayName: 'Connections',
    logoUrl: '/img/piece/community/connections.png',
  },
  '@activepieces/piece-constant-contact': {
    displayName: 'Constant Contact',
    logoUrl: '/img/piece/community/constant-contact.png',
  },
  '@activepieces/piece-contentful': {
    displayName: 'Contentful',
    logoUrl: '/img/piece/community/contentful.png',
  },
  '@activepieces/piece-contiguity': {
    displayName: 'Contiguity',
    logoUrl: '/img/piece/community/contiguity.png',
  },
  '@activepieces/piece-convertkit': {
    displayName: 'ConvertKit',
    logoUrl: '/img/piece/community/convertkit.png',
  },
  '@activepieces/piece-crypto': {
    displayName: 'Crypto',
    logoUrl: '/img/piece/community/crypto.png',
  },
  '@activepieces/piece-csv': {
    displayName: 'CSV',
    logoUrl: '/img/piece/community/csv.svg',
  },
  '@activepieces/piece-customer-io': {
    displayName: 'customer.io',
    logoUrl: '/img/piece/community/customer-io.png',
  },
  '@activepieces/piece-data-mapper': {
    displayName: 'Data Mapper',
    logoUrl: '/img/piece/community/data-mapper.png',
  },
  '@activepieces/piece-data-summarizer': {
    displayName: 'Data Summarizer',
    logoUrl: '/img/piece/community/data-summarizer.svg',
  },
  '@activepieces/piece-date-helper': {
    displayName: 'Date Helper',
    logoUrl: '/img/piece/community/date-helper.svg',
  },
  '@activepieces/piece-datocms': {
    displayName: 'Dato CMS',
    logoUrl: '/img/piece/community/datocms.png',
  },
  '@activepieces/piece-deepl': {
    displayName: 'DeepL',
    logoUrl: '/img/piece/community/deepl.png',
  },
  '@activepieces/piece-delay': {
    displayName: 'Delay',
    logoUrl: '/img/piece/community/delay.png',
  },
  '@activepieces/piece-discord': {
    displayName: 'Discord',
    logoUrl: '/img/piece/community/discord.png',
  },
  '@activepieces/piece-discourse': {
    displayName: 'Discourse',
    logoUrl: '/img/piece/community/discourse.png',
  },
  '@activepieces/piece-docusign': {
    displayName: 'Docusign',
    logoUrl: '/img/piece/community/docusign.png',
  },
  '@activepieces/piece-drip': {
    displayName: 'Drip',
    logoUrl: '/img/piece/community/drip.png',
  },
  '@activepieces/piece-dropbox': {
    displayName: 'Dropbox',
    logoUrl: '/img/piece/community/dropbox.png',
  },
  '@activepieces/piece-dust': {
    displayName: 'Dust',
    logoUrl: '/img/piece/community/dust.png',
  },
  '@activepieces/piece-elevenlabs': {
    displayName: 'ElevenLabs',
    logoUrl: '/img/piece/community/elevenlabs.png',
  },
  '@activepieces/piece-facebook-leads': {
    displayName: 'Facebook Leads',
    logoUrl: '/img/piece/community/facebook-leads.png',
  },
  '@activepieces/piece-facebook-pages': {
    displayName: 'Facebook Pages',
    logoUrl: '/img/piece/community/facebook-pages.png',
  },
  '@activepieces/piece-figma': {
    displayName: 'Figma',
    logoUrl: '/img/piece/community/figma.png',
  },
  '@activepieces/piece-file-helper': {
    displayName: 'Files Helper',
    logoUrl: '/img/piece/community/file-helper.svg',
  },
  '@activepieces/piece-fliqr-ai': {
    displayName: 'Fliqr AI',
    logoUrl: '/img/piece/community/fliqr-ai.png',
  },
  '@activepieces/piece-flow-control': {
    displayName: 'Flow Control',
    logoUrl: '/img/piece/community/flow-control.svg',
  },
  '@activepieces/piece-flowise': {
    displayName: 'Flowise',
    logoUrl: '/img/piece/community/flowise.png',
  },
  '@activepieces/piece-flowlu': {
    displayName: 'Flowlu',
    logoUrl: '/img/piece/community/flowlu.png',
  },
  '@activepieces/piece-formbricks': {
    displayName: 'Formbricks',
    logoUrl: '/img/piece/community/formbricks.png',
  },
  '@activepieces/piece-frame': {
    displayName: 'Frame',
    logoUrl: '/img/piece/community/frame.png',
  },
  '@activepieces/piece-freshdesk': {
    displayName: 'Freshdesk',
    logoUrl: '/img/piece/community/freshdesk.png',
  },
  '@activepieces/piece-freshsales': {
    displayName: 'Freshsales',
    logoUrl: '/img/piece/community/freshsales.png',
  },
  '@activepieces/piece-sftp': {
    displayName: 'FTP/SFTP',
    logoUrl: '/img/piece/community/sftp.svg',
  },
  '@activepieces/piece-gameball': {
    displayName: 'Gameball',
    logoUrl: '/img/piece/community/gameball.png',
  },
  '@activepieces/piece-gcloud-pubsub': {
    displayName: 'GCloud Pub/Sub',
    logoUrl: '/img/piece/community/gcloud-pubsub.png',
  },
  '@activepieces/piece-generatebanners': {
    displayName: 'GenerateBanners',
    logoUrl: '/img/piece/community/generatebanners.png',
  },
  '@activepieces/piece-geremy': {
    displayName: 'Geremy',
    logoUrl: '/img/piece/community/geremy.png',
  },
  '@activepieces/piece-geremy-admin': {
    displayName: 'Geremy Admin',
    logoUrl: '/img/piece/community/geremy.png',
  },
  '@activepieces/piece-ghostcms': {
    displayName: 'GhostCMS',
    logoUrl: '/img/piece/community/ghostcms.png',
  },
  '@activepieces/piece-gistly': {
    displayName: 'Gistly',
    logoUrl: '/img/piece/community/gistly.svg',
  },
  '@activepieces/piece-github': {
    displayName: 'GitHub',
    logoUrl: '/img/piece/community/github.png',
  },
  '@activepieces/piece-gitlab': {
    displayName: 'GitLab',
    logoUrl: '/img/piece/community/gitlab.png',
  },
  '@activepieces/piece-gmail': {
    displayName: 'Gmail',
    logoUrl: '/img/piece/community/gmail.png',
  },
  '@activepieces/piece-google-calendar': {
    displayName: 'Google Calendar',
    logoUrl: '/img/piece/community/google-calendar.png',
  },
  '@activepieces/piece-google-contacts': {
    displayName: 'Google Contacts',
    logoUrl: '/img/piece/community/google-contacts.png',
  },
  '@activepieces/piece-google-docs': {
    displayName: 'Google Docs',
    logoUrl: '/img/piece/community/google-docs.png',
  },
  '@activepieces/piece-google-drive': {
    displayName: 'Google Drive',
    logoUrl: '/img/piece/community/google-drive.png',
  },
  '@activepieces/piece-google-forms': {
    displayName: 'Google Forms',
    logoUrl: '/img/piece/community/google-forms.png',
  },
  '@activepieces/piece-google-gemini': {
    displayName: 'Google Gemini',
    logoUrl: '/img/piece/community/google-gemini.png',
  },
  '@activepieces/piece-google-my-business': {
    displayName: 'Google My Business',
    logoUrl: '/img/piece/community/google-my-business.png',
  },
  '@activepieces/piece-google-search-console': {
    displayName: 'Google Search Console',
    logoUrl: '/img/piece/community/google-search-console.png',
  },
  '@activepieces/piece-google-sheets': {
    displayName: 'Google Sheets',
    logoUrl: 'https://cdn.activepieces.com/pieces/google-sheets.png',
  },
  '@activepieces/piece-google-tasks': {
    displayName: 'Google Tasks',
    logoUrl: '/img/piece/community/google-tasks.png',
  },
  '@activepieces/piece-gotify': {
    displayName: 'Gotify',
    logoUrl: '/img/piece/community/gotify.png',
  },
  '@activepieces/piece-gravityforms': {
    displayName: 'Gravity Forms',
    logoUrl: '/img/piece/community/gravityforms.svg',
  },
  '@activepieces/piece-grist': {
    displayName: 'Grist',
    logoUrl: '/img/piece/community/grist.png',
  },
  '@activepieces/piece-hackernews': {
    displayName: 'Hacker News',
    logoUrl: '/img/piece/community/hackernews.png',
  },
  '@activepieces/piece-harvest': {
    displayName: 'Harvest',
    logoUrl: '/img/piece/community/harvest.png',
  },
  '@activepieces/piece-heartbeat': {
    displayName: 'Heartbeat',
    logoUrl: '/img/piece/community/heartbeat.png',
  },
  '@activepieces/piece-http': {
    displayName: 'HTTP',
    logoUrl: '/img/piece/community/http.png',
  },
  '@activepieces/piece-hubspot': {
    displayName: 'HubSpot',
    logoUrl: '/img/piece/community/hubspot.png',
  },
  '@activepieces/piece-forms': {
    displayName: 'Human Input',
    logoUrl: '/img/piece/community/forms.svg',
  },
  '@activepieces/piece-image-ai': {
    displayName: 'Image AI',
    logoUrl: '/img/piece/community/image-ai.svg',
  },
  '@activepieces/piece-image-helper': {
    displayName: 'Image Helper',
    logoUrl: '/img/piece/community/image-helper.png',
  },
  '@activepieces/piece-imap': {
    displayName: 'IMAP',
    logoUrl: '/img/piece/community/imap.png',
  },
  '@activepieces/piece-instagram-business': {
    displayName: 'Instagram for Business',
    logoUrl: '/img/piece/community/instagram-business.png',
  },
  '@activepieces/piece-instasent': {
    displayName: 'Instasent',
    logoUrl: '/img/piece/community/instasent.jpg',
  },
  '@activepieces/piece-intercom': {
    displayName: 'Intercom',
    logoUrl: '/img/piece/community/intercom.png',
  },
  '@activepieces/piece-invoiceninja': {
    displayName: 'Invoice Ninja',
    logoUrl: '/img/piece/community/invoiceninja.png',
  },
  '@activepieces/piece-jira-cloud': {
    displayName: 'Jira Cloud',
    logoUrl: '/img/piece/community/jira-cloud.png',
  },
  '@activepieces/piece-jotform': {
    displayName: 'Jotform',
    logoUrl: '/img/piece/community/jotform.svg',
  },
  '@activepieces/piece-json': {
    displayName: 'JSON',
    logoUrl: '/img/piece/community/json.svg',
  },
  '@activepieces/piece-kimai': {
    displayName: 'Kimai',
    logoUrl: '/img/piece/community/kimai.png',
  },
  '@activepieces/piece-kizeo-forms': {
    displayName: 'Kizeo Forms',
    logoUrl: '/img/piece/community/kizeo-forms.png',
  },
  '@activepieces/piece-klear': {
    displayName: 'Klear',
    logoUrl: '/img/piece/community/klear.svg',
  },
  '@activepieces/piece-krisp-call': {
    displayName: 'KrispCall',
    logoUrl: '/img/piece/community/krisp-call.svg',
  },
  '@activepieces/piece-lead-connector': {
    displayName: 'LeadConnector',
    logoUrl: '/img/piece/community/lead-connector.png',
  },
  '@activepieces/piece-lever': {
    displayName: 'Lever',
    logoUrl: '/img/piece/community/lever.png',
  },
  '@activepieces/piece-line': {
    displayName: 'Line Bot',
    logoUrl: '/img/piece/community/line.png',
  },
  '@activepieces/piece-linear': {
    displayName: 'Linear',
    logoUrl: '/img/piece/community/linear.png',
  },
  '@activepieces/piece-linka': {
    displayName: 'Linka',
    logoUrl: '/img/piece/community/linka.png',
  },
  '@activepieces/piece-linkedin': {
    displayName: 'LinkedIn',
    logoUrl: '/img/piece/community/linkedin.png',
  },
  '@activepieces/piece-llmrails': {
    displayName: 'LLMRails',
    logoUrl: '/img/piece/community/llmrails.png',
  },
  '@activepieces/piece-localai': {
    displayName: 'LocalAI',
    logoUrl: '/img/piece/community/localai.jpeg',
  },
  '@activepieces/piece-mailchimp': {
    displayName: 'Mailchimp',
    logoUrl: '/img/piece/community/mailchimp.png',
  },
  '@activepieces/piece-mailer-lite': {
    displayName: 'MailerLite',
    logoUrl: '/img/piece/community/mailer-lite.png',
  },
  '@activepieces/piece-maileroo': {
    displayName: 'Maileroo',
    logoUrl: '/img/piece/community/maileroo.png',
  },
  '@activepieces/piece-mailjet': {
    displayName: 'Mailjet',
    logoUrl: '/img/piece/community/mailjet.svg',
  },
  '@activepieces/piece-mastodon': {
    displayName: 'Mastodon',
    logoUrl: '/img/piece/community/mastodon.png',
  },
  '@activepieces/piece-math-helper': {
    displayName: 'Math Helper',
    logoUrl: '/img/piece/community/math-helper.svg',
  },
  '@activepieces/piece-matomo': {
    displayName: 'Matomo',
    logoUrl: '/img/piece/community/matomo.png',
  },
  '@activepieces/piece-matrix': {
    displayName: 'Matrix',
    logoUrl: '/img/piece/community/matrix.png',
  },
  '@activepieces/piece-mattermost': {
    displayName: 'Mattermost',
    logoUrl: '/img/piece/community/mattermost.png',
  },
  '@activepieces/piece-mautic': {
    displayName: 'Mautic',
    logoUrl: '/img/piece/community/mautic.png',
  },
  '@activepieces/piece-mcp': {
    displayName: 'MCP',
    logoUrl: 'https://cdn.activepieces.com/pieces/mcp.svg',
  },
  '@activepieces/piece-messagebird': {
    displayName: 'MessageBird',
    logoUrl: '/img/piece/community/messagebird.png',
  },
  '@activepieces/piece-metabase': {
    displayName: 'Metabase',
    logoUrl: '/img/piece/community/metabase.png',
  },
  '@activepieces/piece-microsoft-dynamics-365-business-central': {
    displayName: 'Microsoft Dynamics 365 Business Central',
    logoUrl:
      'https://cdn.activepieces.com/pieces/microsoft-dynamics-365-business-central.png',
  },
  '@activepieces/piece-microsoft-dynamics-crm': {
    displayName: 'Microsoft Dynamics CRM',
    logoUrl: '/img/piece/community/microsoft-dynamics-crm.png',
  },
  '@activepieces/piece-microsoft-excel-365': {
    displayName: 'Microsoft Excel 365',
    logoUrl: '/img/piece/community/microsoft-excel-365.png',
  },
  '@activepieces/piece-microsoft-onedrive': {
    displayName: 'Microsoft OneDrive',
    logoUrl: '/img/piece/community/microsoft-onedrive.png',
  },
  '@activepieces/piece-microsoft-outlook': {
    displayName: 'Microsoft Outlook',
    logoUrl: '/img/piece/community/microsoft-outlook.jpg',
  },
  '@activepieces/piece-microsoft-outlook-calendar': {
    displayName: 'Microsoft Outlook Calendar',
    logoUrl: '/img/piece/community/microsoft-outlook-calendar.png',
  },
  '@activepieces/piece-microsoft-sharepoint': {
    displayName: 'Microsoft SharePoint',
    logoUrl: '/img/piece/community/microsoft-sharepoint.png',
  },
  '@activepieces/piece-microsoft-teams': {
    displayName: 'Microsoft Teams',
    logoUrl: '/img/piece/community/microsoft-teams.png',
  },
  '@activepieces/piece-mindee': {
    displayName: 'Mindee',
    logoUrl: '/img/piece/community/mindee.png',
  },
  '@activepieces/piece-mixpanel': {
    displayName: 'Mixpanel',
    logoUrl: '/img/piece/community/mixpanel.png',
  },
  '@activepieces/piece-monday': {
    displayName: 'monday.com',
    logoUrl: '/img/piece/community/monday.png',
  },
  '@activepieces/piece-moxie-crm': {
    displayName: 'Moxie',
    logoUrl: '/img/piece/community/moxie-crm.png',
  },
  '@activepieces/piece-mysql': {
    displayName: 'MySQL',
    logoUrl: '/img/piece/community/mysql.png',
  },
  '@activepieces/piece-nifty': {
    displayName: 'Nifty',
    logoUrl: '/img/piece/community/nifty.png',
  },
  '@activepieces/piece-nocodb': {
    displayName: 'NocoDB',
    logoUrl: '/img/piece/community/nocodb.png',
  },
  '@activepieces/piece-notion': {
    displayName: 'Notion',
    logoUrl: '/img/piece/community/notion.png',
  },
  '@activepieces/piece-ntfy': {
    displayName: 'ntfy',
    logoUrl: '/img/piece/community/ntfy.png',
  },
  '@activepieces/piece-odoo': {
    displayName: 'Odoo',
    logoUrl: '/img/piece/community/odoo.png',
  },
  '@activepieces/piece-onfleet': {
    displayName: 'Onfleet',
    logoUrl: '/img/piece/community/onfleet.png',
  },
  '@activepieces/piece-openai': {
    displayName: 'OpenAI',
    logoUrl: '/img/piece/community/openai.png',
  },
  '@activepieces/piece-open-router': {
    displayName: 'OpenRouter',
    logoUrl: '/img/piece/community/open-router.png',
  },
  '@activepieces/piece-pastebin': {
    displayName: 'Pastebin',
    logoUrl: '/img/piece/community/pastebin.png',
  },
  '@activepieces/piece-pastefy': {
    displayName: 'Pastefy',
    logoUrl: '/img/piece/community/pastefy.png',
  },
  '@activepieces/piece-pdf': {
    displayName: 'PDF',
    logoUrl: '/img/piece/community/pdf.svg',
  },
  '@activepieces/piece-perplexity-ai': {
    displayName: 'Perplexity AI',
    logoUrl: '/img/piece/community/perplexity-ai.png',
  },
  '@activepieces/piece-photoroom': {
    displayName: 'Photoroom',
    logoUrl: '/img/piece/community/photoroom.png',
  },
  '@activepieces/piece-pipedrive': {
    displayName: 'Pipedrive',
    logoUrl: '/img/piece/community/pipedrive.png',
  },
  '@activepieces/piece-poper': {
    displayName: 'Poper',
    logoUrl: '/img/piece/community/poper.png',
  },
  '@activepieces/piece-postgres': {
    displayName: 'Postgres',
    logoUrl: '/img/piece/community/postgres.png',
  },
  '@activepieces/piece-posthog': {
    displayName: 'PostHog',
    logoUrl: '/img/piece/community/posthog.png',
  },
  '@activepieces/piece-pushover': {
    displayName: 'Pushover',
    logoUrl: '/img/piece/community/pushover.png',
  },
  '@activepieces/piece-pylon': {
    displayName: 'Pylon',
    logoUrl: '/img/piece/community/pylon.png',
  },
  '@activepieces/piece-qdrant': {
    displayName: 'Qdrant',
    logoUrl: '/img/piece/community/qdrant.png',
  },
  '@activepieces/piece-qrcode': {
    displayName: 'QR Code',
    logoUrl: '/img/piece/community/qrcode.png',
  },
  '@activepieces/piece-queue': {
    displayName: 'Queue',
    logoUrl: '/img/piece/community/queue.svg',
  },
  '@activepieces/piece-quickzu': {
    displayName: 'Quickzu',
    logoUrl: '/img/piece/community/quickzu.png',
  },
  '@activepieces/piece-rabbitmq': {
    displayName: 'RabbitMQ',
    logoUrl: '/img/piece/community/rabbitmq.png',
  },
  '@activepieces/piece-razorpay': {
    displayName: 'Razorpay',
    logoUrl: '/img/piece/community/razorpay.png',
  },
  '@activepieces/piece-retune': {
    displayName: 're:tune',
    logoUrl: '/img/piece/community/retune.png',
  },
  '@activepieces/piece-reachinbox': {
    displayName: 'Reachinbox',
    logoUrl: '/img/piece/community/reachinbox.png',
  },
  '@activepieces/piece-reoon-verifier': {
    displayName: 'Reoon Email Verifier',
    logoUrl: '/img/piece/community/reoon-verifier.png',
  },
  '@activepieces/piece-resend': {
    displayName: 'Resend',
    logoUrl: '/img/piece/community/resend.png',
  },
  '@activepieces/piece-retable': {
    displayName: 'Retable',
    logoUrl: '/img/piece/community/retable.png',
  },
  '@activepieces/piece-robolly': {
    displayName: 'Robolly',
    logoUrl: '/img/piece/community/robolly.png',
  },
  '@activepieces/piece-rss': {
    displayName: 'RSS Feed',
    logoUrl: '/img/piece/community/rss.png',
  },
  '@activepieces/piece-saastic': {
    displayName: 'Saastic',
    logoUrl: '/img/piece/community/saastic.png',
  },
  '@activepieces/piece-sage': {
    displayName: 'Sage Business Cloud Accounting',
    logoUrl: '/img/piece/community/sage.png',
  },
  '@activepieces/piece-salesforce': {
    displayName: 'Salesforce',
    logoUrl: '/img/piece/community/salesforce.png',
  },
  '@activepieces/piece-scenario': {
    displayName: 'Scenario',
    logoUrl: '/img/piece/community/scenario.png',
  },
  '@activepieces/piece-schedule': {
    displayName: 'Schedule',
    logoUrl: '/img/piece/community/schedule.png',
  },
  '@activepieces/piece-segment': {
    displayName: 'Segment',
    logoUrl: '/img/piece/community/segment.png',
  },
  '@activepieces/piece-sendfox': {
    displayName: 'SendFox',
    logoUrl: '/img/piece/community/sendfox.png',
  },
  '@activepieces/piece-sendgrid': {
    displayName: 'SendGrid',
    logoUrl: '/img/piece/community/sendgrid.png',
  },
  '@activepieces/piece-sendy': {
    displayName: 'Sendy',
    logoUrl: '/img/piece/community/sendy.png',
  },
  '@activepieces/piece-sessions-us': {
    displayName: 'Sessions.us',
    logoUrl: '/img/piece/community/sessions-us.png',
  },
  '@activepieces/piece-shopify': {
    displayName: 'Shopify',
    logoUrl: '/img/piece/community/shopify.png',
  },
  '@activepieces/piece-simplepdf': {
    displayName: 'SimplePDF',
    logoUrl: '/img/piece/community/simplepdf.png',
  },
  '@activepieces/piece-slack': {
    displayName: 'Slack',
    logoUrl: '/img/piece/community/slack.png',
  },
  '@activepieces/piece-smaily': {
    displayName: 'Smaily',
    logoUrl: '/img/piece/community/smaily.png',
  },
  '@activepieces/piece-smtp': {
    displayName: 'SMTP',
    logoUrl: '/img/piece/community/smtp.png',
  },
  '@activepieces/piece-snowflake': {
    displayName: 'Snowflake',
    logoUrl: '/img/piece/community/snowflake.png',
  },
  '@activepieces/piece-soap': {
    displayName: 'SOAP',
    logoUrl: '/img/piece/community/soap.png',
  },
  '@activepieces/piece-sperse': {
    displayName: 'Sperse',
    logoUrl: '/img/piece/community/sperse.png',
  },
  '@activepieces/piece-spotify': {
    displayName: 'Spotify',
    logoUrl: '/img/piece/community/spotify.png',
  },
  '@activepieces/piece-square': {
    displayName: 'Square',
    logoUrl: '/img/piece/community/square.png',
  },
  '@activepieces/piece-stability-ai': {
    displayName: 'Stability AI',
    logoUrl: '/img/piece/community/stability-ai.png',
  },
  '@activepieces/piece-stable-diffusion-webui': {
    displayName: 'Stable Dffusion web UI',
    logoUrl: '/img/piece/community/stable-diffusion-webui.png',
  },
  '@activepieces/piece-store': {
    displayName: 'Storage',
    logoUrl: '/img/piece/community/store.png',
  },
  '@activepieces/piece-straico': {
    displayName: 'Straico',
    logoUrl: '/img/piece/community/straico.png',
  },
  '@activepieces/piece-stripe': {
    displayName: 'Stripe',
    logoUrl: '/img/piece/community/stripe.png',
  },
  '@activepieces/piece-subflows': {
    displayName: 'Sub Flows',
    logoUrl: '/img/piece/community/subflows.svg',
  },
  '@activepieces/piece-supabase': {
    displayName: 'Supabase',
    logoUrl: '/img/piece/community/supabase.png',
  },
  '@activepieces/piece-supadata': {
    displayName: 'Supadata',
    logoUrl: '/img/piece/community/supadata.svg',
  },
  '@activepieces/piece-surveymonkey': {
    displayName: 'SurveyMonkey',
    logoUrl: '/img/piece/community/surveymonkey.png',
  },
  '@activepieces/piece-tables': {
    displayName: 'Tables',
    logoUrl: '/img/piece/community/tables.svg',
  },
  '@activepieces/piece-tags': {
    displayName: 'Tags',
    logoUrl: '/img/piece/community/tags.svg',
  },
  '@activepieces/piece-talkable': {
    displayName: 'Talkable',
    logoUrl:
      'https://www.talkable.com/wp-content/uploads/2021/12/talkable-favicon.svg',
  },
  '@activepieces/piece-tally': {
    displayName: 'Tally',
    logoUrl: '/img/piece/community/tally.png',
  },
  '@activepieces/piece-taskade': {
    displayName: 'Taskade',
    logoUrl: '/img/piece/community/taskade.png',
  },
  '@activepieces/piece-telegram-bot': {
    displayName: 'Telegram Bot',
    logoUrl: '/img/piece/community/telegram-bot.png',
  },
  '@activepieces/piece-text-ai': {
    displayName: 'Text AI',
    logoUrl: '/img/piece/community/text-ai.svg',
  },
  '@activepieces/piece-text-helper': {
    displayName: 'Text Helper',
    logoUrl: '/img/piece/community/text-helper.svg',
  },
  '@activepieces/piece-tidycal': {
    displayName: 'TidyCal',
    logoUrl: '/img/piece/community/tidycal.png',
  },
  '@activepieces/piece-todoist': {
    displayName: 'Todoist',
    logoUrl: '/img/piece/community/todoist.png',
  },
  '@activepieces/piece-totalcms': {
    displayName: 'Total CMS',
    logoUrl: '/img/piece/community/totalcms.png',
  },
  '@activepieces/piece-trello': {
    displayName: 'Trello',
    logoUrl: '/img/piece/community/trello.png',
  },
  '@activepieces/piece-twilio': {
    displayName: 'Twilio',
    logoUrl: '/img/piece/community/twilio.png',
  },
  '@activepieces/piece-twin-labs': {
    displayName: 'Twin Web Agent',
    logoUrl: '/img/piece/community/twin-labs.png',
  },
  '@activepieces/piece-twitter': {
    displayName: 'Twitter',
    logoUrl: '/img/piece/community/twitter.png',
  },
  '@activepieces/piece-typeform': {
    displayName: 'Typeform',
    logoUrl: '/img/piece/community/typeform.png',
  },
  '@activepieces/piece-upgradechat': {
    displayName: 'Upgrade.chat',
    logoUrl: '/img/piece/community/upgradechat.png',
  },
  '@activepieces/piece-utility-ai': {
    displayName: 'Utility AI',
    logoUrl: '/img/piece/community/utility-ai.svg',
  },
  '@activepieces/piece-vbout': {
    displayName: 'VBOUT',
    logoUrl: '/img/piece/community/vbout.png',
  },
  '@activepieces/piece-village': {
    displayName: 'Village',
    logoUrl: '/img/piece/community/village.png',
  },
  '@activepieces/piece-vtex': {
    displayName: 'VTEX',
    logoUrl: '/img/piece/community/vtex.png',
  },
  '@activepieces/piece-webflow': {
    displayName: 'Webflow',
    logoUrl: '/img/piece/community/webflow.png',
  },
  '@activepieces/piece-webhook': {
    displayName: 'Webhook',
    logoUrl: '/img/piece/community/webhook.svg',
  },
  '@activepieces/piece-webling': {
    displayName: 'Webling',
    logoUrl: '/img/piece/community/webling.png',
  },
  '@activepieces/piece-wedof': {
    displayName: 'Wedof',
    logoUrl: '/img/piece/community/wedof.svg',
  },
  '@activepieces/piece-whatsable': {
    displayName: 'Whatsable',
    logoUrl: '/img/piece/community/whatsable.png',
  },
  '@activepieces/piece-whatsapp': {
    displayName: 'WhatsApp Business',
    logoUrl: '/img/piece/community/whatsapp.png',
  },
  '@activepieces/piece-woocommerce': {
    displayName: 'WooCommerce',
    logoUrl: '/img/piece/community/woocommerce.png',
  },
  '@activepieces/piece-wootric': {
    displayName: 'Wootric',
    logoUrl:
      'https://assets-production.wootric.com/assets/wootric-is-now-inmoment-250x108-85cb4900c62ff4d33200abafee7d63372d410abc5bf0cab90e80a07d4f4e5a31.png',
  },
  '@activepieces/piece-wordpress': {
    displayName: 'WordPress',
    logoUrl: '/img/piece/community/wordpress.png',
  },
  '@activepieces/piece-xero': {
    displayName: 'Xero',
    logoUrl: '/img/piece/community/xero.png',
  },
  '@activepieces/piece-xml': {
    displayName: 'XML',
    logoUrl: '/img/piece/community/xml.png',
  },
  '@activepieces/piece-youtube': {
    displayName: 'YouTube',
    logoUrl: '/img/piece/community/youtube.png',
  },
  '@activepieces/piece-zendesk': {
    displayName: 'Zendesk',
    logoUrl: '/img/piece/community/zendesk.png',
  },
  '@activepieces/piece-zerobounce': {
    displayName: 'ZeroBounce',
    logoUrl: '/img/piece/community/zerobounce.png',
  },
  '@activepieces/piece-zoho-books': {
    displayName: 'Zoho Books',
    logoUrl: '/img/piece/community/zoho-books.png',
  },
  '@activepieces/piece-zoho-crm': {
    displayName: 'Zoho CRM',
    logoUrl: '/img/piece/community/zoho-crm.png',
  },
  '@activepieces/piece-zoho-invoice': {
    displayName: 'Zoho Invoice',
    logoUrl: '/img/piece/community/zoho-invoice.png',
  },
  '@activepieces/piece-zoom': {
    displayName: 'Zoom',
    logoUrl: '/img/piece/community/zoom.png',
  },
  '@activepieces/piece-zuora': {
    displayName: 'Zuora',
    logoUrl: '/img/piece/community/zuora.png',
  },
  unknown_trigger: {
    displayName: 'Empty Trigger',
    logoUrl: '/img/piece/community/empty-trigger.svg',
  },
};

export function getPieceDisplayData(pieceName: string): {
  displayName: string;
  logoUrl: string;
} {
  return PIECE_LOGOS[pieceName];
}
